import { render, staticRenderFns } from "./echartsShow.vue?vue&type=template&id=5d825846&scoped=true&"
import script from "./echartsShow.vue?vue&type=script&lang=js&"
export * from "./echartsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d825846",
  null
  
)

export default component.exports